import Vue from 'vue'
import HotSpotTemplate from './hotspot.vue'

const HotSpot = Vue.extend(HotSpotTemplate)

export function templateHotSpotVue({ module, exposeDirective }) {
  const hotspot = new HotSpot({
    propsData: {
      module
    },
    directives: {
      tangramExpose: exposeDirective
    }
  }).$mount()
  return hotspot.$el
}
